// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"d08f2d04","202":"800630f9","453":"4a149e06"}[chunkId] + ".chunk.js";
};